(function (app) {
    'use strict';

    app.factory('bookingServices', bookingServices);
    /*@ngInject*/
    function bookingServices(queryservice, $q){
        return  {
            addBooking:addBooking,
            requestBooking:requestBooking,
            addToWaitingList:addToWaitingList
        };

        function addBooking(fctArgsJson, cId) {
            if(fctArgsJson && cId){
                fctArgsJson.cId = cId;
                var fctName= "obtCalHelper.addBooking";
                return queryservice.callServer(fctName,fctArgsJson);
            }else{
                return $q.when({});
            }
        }

        function addToWaitingList(fctArgsJson, cId) {
            if(fctArgsJson && cId){
                fctArgsJson.cId = cId;
                var fctName= "obtCalHelper.addToWaitingList";
                return queryservice.callServer(fctName,fctArgsJson);
            }else{
                return $q.when({});
            }
        }

        function requestBooking(fctArgsJson, cId) {
            if(fctArgsJson && cId){
                fctArgsJson.cId = cId;
                var fctName= "obtCalHelper.requestBooking";
                return queryservice.callServer(fctName,fctArgsJson);
            }else{
                return $q.when({});
            }
        }
    }
})(angular.module('app.data'));



/*****************
 ** WEBPACK FOOTER
 ** ./app/data/booking.services.js
 ** module id = 162
 ** module chunks = 0
 **/